import graphql__cc3c1a75d6b494da1e24 from "./__generated__/RemoveContactFromListDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import FormDialog from "./FormDialog";
import Section from "../form/Section";
import Row from "../form/Row";

type Props = {
    contactIdentifier: string;
    mailingListIdentifier: string;
    mailingListName: string;
    handleCloseDialog: () => void;
}

const RemoveContactFromListDialog: React.FC<Props> = ({contactIdentifier, mailingListIdentifier, mailingListName, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__cc3c1a75d6b494da1e24,
                variables: {
                    input: {
                        mailingListIdentifier: mailingListIdentifier,
                        contactIdentifier: contactIdentifier
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveFromList'})
            }
        )
    }

    const initialValues = {}

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={initialValues}
            headline={intl.formatMessage({id: 'dialog.RemoveContactFromListDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.remove'})}
            dangerous={true}
        >
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.RemoveContactFromListDialog.message'}, {listName: mailingListName})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default RemoveContactFromListDialog;
